// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1qzFO","header":"MergedInvoice_header__2PGwU"};